(function (angular) {
    angular.module("app").controller("__Template__Ctrl", ["$scope", "__Template__Service", function ($scope, __Template__Service) {
        // put angular code here
    }]);
})(angular);